/* unplugin-vue-components disabled */import { render } from "./OverView.vue?vue&type=template&id=24718d62&scoped=true"
import script from "./OverView.vue?vue&type=script&lang=js"
export * from "./OverView.vue?vue&type=script&lang=js"

import "./OverView.vue?vue&type=style&index=0&id=24718d62&lang=scss&scoped=true"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24718d62"]])

export default __exports__